import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
const base_url = environment.base_url;
@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) {
  }

  public getcountstudents(){
    return this.http.get(`${base_url}/api/v1/dashboard/getcountstudents`);
  }

  public getcountcourses(){
    return this.http.get(`${base_url}/api/v1/dashboard/getcountcourses`);
  }

  public getcountteacher(){
    return this.http.get(`${base_url}/api/v1/dashboard/getcountteacher`);
  }

  public getcountexecutive(){
    return this.http.get(`${base_url}/api/v1/dashboard/getcountexecutive`);
  }
  
  public getcountstudentfreezes(){
    return this.http.get(`${base_url}/api/v1/dashboard/getcountstudentfreezes`);
  }

  public getabsentstudent(){
    return this.http.get(`${base_url}/api/v1/dashboard/getabsentstudent`);
  }

  public getdelinquentstudent(){
    return this.http.get(`${base_url}/api/v1/dashboard/getdelinquentstudent`);

  }

  public getfreezesstudent(){
    return this.http.get(`${base_url}/api/v1/dashboard/getfreezesstudent`);

  }
}